import { Stack, Typography } from '@mui/material';
import { MUITable } from 'components/shared/MUITable';
import { SmartIntakeRow } from './SmartIntakeTypes';
import { createSmartIntakeTableColumns } from './SmartIntakeTableConfig';

interface Props {
  rows: SmartIntakeRow[];
  isLoading: boolean;
  emptyMessage: string;
  onReview: (row: SmartIntakeRow) => void;
  onDismiss: (row: SmartIntakeRow) => void;
  dismissingId: string | null;
}

export const SmartIntakeTable = ({ rows, isLoading, emptyMessage, onReview, onDismiss, dismissingId }: Props) => {
  const columns = createSmartIntakeTableColumns({ onReview, onDismiss, dismissingId });

  if (!isLoading && !rows.length) {
    return (
      <Typography color="text.secondary" sx={{ mt: 2 }}>
        {emptyMessage}
      </Typography>
    );
  }

  return (
    <Stack flex={1} overflow="hidden">
      <MUITable<SmartIntakeRow> stickyHeader hover isLoading={isLoading} tableData={rows} columns={columns} />
    </Stack>
  );
};
